import { createSlice, createAsyncThunk, AsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { ITokenOffering } from "./types";

const API_URL = process.env.REACT_APP_API_URL;

interface IOfferingState {
  response: ITokenOffering[];
  loading: boolean;
  error: object;
}

const initialState: IOfferingState = {
  response: [],
  loading: true,
  error: {},
};

export const fetchOfferings = createAsyncThunk(
  "admin/offerings",
  async (service: AxiosResponse) => {
    const uri = `${API_URL}/admin/tokens/getTokenOfferings`;
    try {
      const { data: response } = await service.request.get(uri);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
);

export const offeringsSlice = createSlice({
  name: "offerings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchOfferings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOfferings.fulfilled, (state, { payload }) => {
      console.log("API Offerings Payload ", payload.data);
      state.response = payload.data;
      state.loading = false;
    });
    builder.addCase(fetchOfferings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const offeringsStateSelector = (state: any) => state.offerings;
export default offeringsSlice.reducer;
